import { useParams } from 'react-router-dom';

export function useBusinessIdParam() {
  const { businessAccountId } = useParams<{ businessAccountId: string }>();
  return businessAccountId && !isNaN(Number(businessAccountId)) ? Number(businessAccountId) : null;
}
